import {
  convertEditorStateToHtml,
  convertHtmlToEditorState,
} from 'helpers/formik';

export const Normalizer = {
  fetch: data => {
    return {
      ...data,
      fields: {
        ...data.fields,
        Subject: data.fields.Subject || '',
        Message: convertHtmlToEditorState(data.fields.Message || ''),
        Active: data.fields.Active === 'Yes',
        attachments: [],
        attachSize:
          data.attachments && data.attachments.length
            ? data.attachments.reduce((sum, a) => sum + Number(a.size), 0)
            : 0,
      },
    };
  },

  send: values => {
    const params = {};
    Object.keys(values)
      .filter(
        k =>
          values[k] !== null &&
          !['ProcessEmailSetupID', 'attachments', 'attachSize'].includes(k)
      )
      .forEach(k => {
        if (k === 'Message') {
          params[k] = convertEditorStateToHtml(values[k]);
        } else if (k === 'RecruiterID') {
          params[k] = values[k].value;
        } else if (k === 'Active') {
          params[k] = values[k] ? 'Yes' : 'No';
        } else {
          params[k] = values[k];
        }
      });

    return params;
  },
};
